"use client";

import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  SessionProvider as NextAuthSessionProvider,
  useSession,
} from "next-auth/react";

function SessionCacheBoundary({ children }: { children: React.ReactNode }) {
  const queryClient = useQueryClient();
  const { data: session, status } = useSession();
  const previousSessionUserKeyRef = useRef<string | null | undefined>(
    undefined
  );
  const sessionUserKey =
    status === "authenticated"
      ? session?.user?.id || session?.user?.email || null
      : null;

  useEffect(() => {
    if (status === "loading") {
      return;
    }

    const previousSessionUserKey = previousSessionUserKeyRef.current;

    if (
      previousSessionUserKey !== undefined &&
      previousSessionUserKey !== sessionUserKey
    ) {
      queryClient.clear();
    }

    previousSessionUserKeyRef.current = sessionUserKey;
  }, [queryClient, sessionUserKey, status]);

  return <>{children}</>;
}

/**
 * Session Provider Component
 * Provides NextAuth session context
 */
export function SessionProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextAuthSessionProvider>
      <SessionCacheBoundary>{children}</SessionCacheBoundary>
    </NextAuthSessionProvider>
  );
}
